module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/vertical/atheroma/note_icon-e55990eaf646d93f16945e215fff1f22.png";